import { useLocaleStore } from '@/stores/localeStore';
import type { LocaleSettings } from '@/lib/localeFormatters';

/** Reactive hook for locale settings — use in components instead of getLocaleSettings(). */
export function useLocaleSettings(): LocaleSettings {
  return useLocaleStore((s) => s.settings);
}
